import { render, staticRenderFns } from "./DealsFiltersEvents.vue?vue&type=template&id=73255bc1&scoped=true&"
import script from "./DealsFiltersEvents.vue?vue&type=script&lang=js&"
export * from "./DealsFiltersEvents.vue?vue&type=script&lang=js&"
import style0 from "./DealsFiltersEvents.vue?vue&type=style&index=0&id=73255bc1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73255bc1",
  null
  
)

export default component.exports